module.exports = __webpack_public_path__ + "img/20190418_154809_006.d3041eff.jpg";